import client from '@/services/';

const state = () => ({
    all: [],
    one: {}
});

const getters = {
    all: state => state.all,
    one: state => state.one
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
};

const actions = {
    async getAll(cxt, payload) {
        let { data } = await client.get('assignation');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllClientP(cxt, payload = {userId: 0,texte:'', page: 1, etatEntrepriseCode: '', regionId: '', formeJuridiqueId: '', produitId: '', ifu:'', raisonSociale: '', startDate: '', endDate: ''}) {
        let { data } =payload.texte !== '' ? await client.get('assignation/filtered/'+payload.page, {params: {texte: payload.texte}}) : await client.get('assignation/'+payload.userId+'/'+payload.page, {params: {etatEntrepriseCode: payload.etatEntrepriseCode, regionId: payload.regionId, formeJuridiqueId: payload.formeJuridiqueId, produitId: payload.produitId, ifu: payload.ifu, raisonSociale: payload.raisonSociale, startDate: payload.startDate, endDate: payload.endDate}});
        cxt.commit("SET_ALL", {
            loaded: true, ...data, number: data.number+1,
            content: data.content || []
        })
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP(cxt, payload = {}) {
        let { data } = await client.get('assignation/'+payload);
        cxt.commit("SET_ALL", {
            loaded: true, ...data, number: data.number+1,
            content: data.content || []
        })
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) {
        let { data } = await client.get('assignation/one/'+id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('assignation/edit/'+payload.id, payload) : await client.post('assignation/add', payload);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('assignation/delete/'+id);
        cxt.commit("SET_ONE", data);
        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
